export default "__VITE_ASSET__BspY8my___"